import type {
  GetDocumentsRequestType,
  GetDocumentsResponseType,
} from 'entities/document/api/types';
import { stringifyUrlQuery } from 'helpers';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const getDocuments = async (
  queryParams: GetDocumentsRequestType,
): Promise<GetDocumentsResponseType> => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const query = stringifyUrlQuery(queryParams as any);
  const url = `/api/v2/documents${query}`;
  const response = await apiAuthClient.get<GetDocumentsResponseType>(url);

  return response.data;
};
